import React, { useState, useEffect } from 'react';
import classnames from 'classnames';

import { useConfigStore, useMapStateStore } from '../../../../stores';

import POIIcon from './POIIcon';
import HidePOIIcon from './HidePOIIcon';

import '../MapControls.scss';

const MapControlsPOIToggle = () => {
  const [ enablePOIToggle, setEnablePOIToggle ] = useState( false );

  const mapConfig = useConfigStore((state) => state.mapConfig);
  const POIVisible = useMapStateStore((state) => state.POIVisible);
  const setPOIVisible = useMapStateStore((state) => state.setPOIVisible);

  const { googleMapsConfig } = mapConfig || {};

  useEffect( () => {
    if ( googleMapsConfig ) {
      const { enablePOI } = googleMapsConfig;
      if ( enablePOI ) {
        setEnablePOIToggle( true );
      }
    }
  }, [ googleMapsConfig ] );

  return enablePOIToggle && (
    <div className="mapControlToggle mapControlToggle--pois">
      <button
        type="button"
        className={classnames( 'mapControlToggle-toggleOption', { 'mapControlToggle-toggleOption--show': !POIVisible } )}
        onClick={(e) => {
          e.currentTarget.blur();
          setPOIVisible( true );
        }}
      >
        <POIIcon />
      </button>

      <button
        type="button"
        className={classnames( 'mapControlToggle-toggleOption', { 'mapControlToggle-toggleOption--show': POIVisible } )}
        onClick={(e) => {
          e.currentTarget.blur();
          setPOIVisible( false );
        }}
      >
        <HidePOIIcon />
      </button>

    </div>
  );
};

export default MapControlsPOIToggle;
